export const estimateSurvey = {
  'estimate_survey.continue': 'Pokračovat',
  'estimate_survey.skip': 'Přeskočit',
  'estimate_survey.send': 'Odeslat',

  // address
  'estimate_survey.steps.address.title': 'Zadejte adresu nemovitosti',
  'estimate_survey.steps.address.title.tooltip':
    'Zadejte jméno ulice, číslo popisné a název obce. Poloha a adresa nemovitosti mají na její hodnotu zcela zásadní vliv.',
  'estimate_survey.fields.address.disclaimer':
    'Jedná se o nemovitost bez adresy?',
  'estimate_survey.fields.address.search_for_parcel':
    'Chcete-li odhad <b>pro pozemek</b>, pokračujte ',
  'estimate_survey.fields.address.parcel_link': 'bez zadání adresy',

  // parcel
  'estimate_survey.steps.land_registry.title':
    'Doplňte katastrální území a parcelní číslo',
  'estimate_survey.fields.land_registry.registry.label': 'Katastrální území ',
  'estimate_survey.fields.land_registry.parcel.label': 'Parcelní číslo',

  // address confirmation
  'estimate_survey.steps.confirm_address.question': 'Je tato adresa správná?',
  'estimate_survey.steps.confirm_address.not_found.title':
    'Nenašli jsme žádnou adresu.',
  'estimate_survey.steps.confirm_address.not_found.subtitle':
    'Zkuste to prosím znovu.',
  'estimate_survey.steps.confirm_address.buttons.next': 'Ano, je správná',
  'estimate_survey.steps.confirm_address.buttons.back': 'Upravit',

  // other estate type
  'estimate_survey.steps.other_estate_type.title':
    'O jaký typ budovy se jedná?',

  // estate type
  'estimate_survey.steps.estate_type.title':
    'Pro jaký typ nemovitosti hledáte odhad?',
  'estimate_survey.steps.estate_type.house': 'Celý dům',
  'estimate_survey.steps.estate_type.flat': 'Byt',

  // OTHER ESTATE TYPES
  'estimate_survey.steps.other_estate_type.apartment_building': 'Bytový dům',
  'estimate_survey.steps.other_estate_type.family_house': 'Rodinný dům',
  'estimate_survey.steps.other_estate_type.other': 'Něco jiného',

  // unit number selection
  'estimate_survey.steps.unit_number_selection.title': 'Vyberte jednotku',
  'estimate_survey.steps.unit_number_selection.title.tooltip':
    'Výběrem bytové jednotky se budete moci k odhadu ceny bytu kdykoliv vrátit, aniž byste museli zadávat všechny informace znovu. Pokud číslo/jméno vlastníka byt. jednotky neznáte nebo jste ho nenašli v seznamu, klikněte na tlačítko "Přeskočit".',
  'estimate_survey.fields.unit_number.input_label':
    'Stačí <b>číslo</b> jednotky nebo <b>jméno</b> vlastníka:',
  'estimate_survey.fields.unit_number.unit_list_item.single_owner':
    'č. {buildingNumber}/{unitNumber} - {owner}',
  'estimate_survey.fields.unit_number.unit_list_item.multiple_owners': `č. {buildingNumber}/{unitNumber} - {ownersCount} {ownersCount, plural,
    one {vlastník}
    few {vlastníci}
    other {vlastníků}
  }`,
  'estimate_survey.fields.unit_number.show_all_units':
    'Zobrazit všechny jednotky ({count})...',
  'estimate_survey.fields.unit_number.unit_not_in_list':
    'Jednotka není v seznamu',
  'estimate_survey.fields.unit_number.input_placeholder':
    'např. 11 nebo Jan N.',

  // no estate found
  'estimate_survey.fields.no_estate_found.info':
    'Bohužel, na této adrese jsme nenalezli nemovitost.',
  'estimate_survey.fields.no_estate_found.try_editing_address':
    'Zkuste adresu upravit.',
  'estimate_survey.steps.no_estate_found.button': 'Upravit adresu',

  // other estate - living area
  'estimate_survey.field.other_estate_living_area.input.label':
    'Podlahová plocha',
  'estimate_survey.field.other_estate_living_area.input.required':
    'Zadejte prosím podlahovou plochu',
  'estimate_survey.field.other_estate_living_area.input.min':
    'Zadejte, prosím, výměru plochy alespoň 15m&nbsp;<sup>2</sup>.',
  'estimate_survey.field.other_estate_living_area.input.max':
    'Maximální výměra je 1200&nbsp;m<sup>2</sup>. Prosím, upravte údaj.',

  // wanna sell with broker step
  'estimate_survey.field.wanna_sell_with_broker.yes': 'Ano',
  'estimate_survey.field.wanna_sell_with_broker.maybe': 'Možná',
  'estimate_survey.field.wanna_sell_with_broker.no': 'Ne',
  'estimate_survey.step.wants_broker.title':
    'Přemýšlíte o prodeji s realitní kanceláří?',

  // estate contact step
  'estimate_survey.steps.contact.title':
    'Pro získání odhadu vyplňte kontaktní údaje',
  'estimate_survey.steps.contact.subtitle':
    'Zjistěte nezávazně a zdarma odhad ceny nemovitosti a jak nejlépe prodat.',

  'estimate_survey.steps.contact.name.required': 'Vyplňte prosím jméno',
  'estimate_survey.steps.contact.email.required':
    'Vyplňte prosím platný e-mail',
  'estimate_survey.steps.contact.phone.required': 'Vyplňte prosím telefon',
  'estimate_survey.steps.contact.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',
  'estimate_survey.steps.contact.cta': 'Získat odhad ZDARMA',

  'estimate_survey.steps.contact.footer': 'Stačí mi orientační online odhad',

  // email step
  'estimate_survey.steps.email.title':
    'Váš odhad ceny {estateType} je připravený',
  'estimate_survey.steps.email.title.bc':
    'Váš odhad ceny {estateType} je připravený k&nbsp;odeslání',
  'estimate_survey.steps.email.subtitle':
    'Stačí zadat váš e-mail, na který vám odhad ceny okamžitě pošleme.',
  'estimate_survey.steps.email.label': 'E-mail pro&nbsp;zaslání odhadu',
  'estimate_survey.steps.email.placeholder': 'E-mail&nbsp;pro zaslání odhadu',
  'estimate_survey.steps.email.text':
    'Vaše údaje jsou u nás v bezpečí. Odesláním souhlasíte se <gdpr>zpracováním osobních údajů</gdpr>.',
  'estimate_survey.steps.email.email.required': 'Vyplňte prosím platný e-mail',
  'estimate_survey.steps.email.footer': 'Nechci odhad odeslat na e-mail',

  /*
   * Contact split experiment
   *
   */

  // email step
  'estimate_survey.steps.contact_split.email.title':
    'Váš orientační odhad ceny {estateType} je připravený',
  'estimate_survey.steps.contact_split.email.subtitle':
    'Stačí zadat váš e-mail, na který vám odhad ceny pošleme.',
  'estimate_survey.steps.contact_split.email.email':
    'E-mail pro zaslání odhadu',
  'estimate_survey.steps.contact_split.email.text':
    'Vaše údaje jsou u nás v bezpečí. Odesláním souhlasíte se <gdpr>zpracováním osobních údajů</gdpr>.',
  'estimate_survey.steps.contact_split.email.email.required':
    'Vyplňte prosím platný e-mail',
  'estimate_survey.steps.contact_split.email.cta': 'Získat odhad ZDARMA',

  // flat area & amenities
  'estimate_survey.step.flat_area_and_amenities.title':
    'Zadejte základní parametry bytu',
  'estimate_survey.step.flat_area_and_amenities.title.check':
    'Ověřte či opravte parametry bytu',
  'estimate_survey.step.flat_area_and_amenities.tooltip':
    'Do podlahové plochy bytu se započítává veškerá vnitřní plocha bytu včetně všech zastavěných ploch, jako jsou nosné stěny i příčky, sloupy, pilíře, vestavěné skříně apod. Nezapočítávají se sem vnější plochy bytu jako je balkon, terasa, zahrada nebo sklep. Tyto plochy můžete uvést po zaškrtnutí konkrétních příslušenství bytu.',
  'estimate_survey.step.flat_area_and_amenities.amenities':
    'Příslušenství bytu',
  'estimate_survey.step.flat_area_and_amenities.area.required':
    'Vyplňte prosím podlahovou plochu bytu v m<sup>2</sup>',
  'estimate_survey.step.flat_area_and_amenities.area.valid':
    'Zadejte prosím správnou podlahovou plochu, minimální plocha pro odhad je 10 m<sup>2</sup>',
  'estimate_survey.step.flat_area_and_amenities.amenities.title':
    'Příslušenství bytu',
  'estimate_survey.step.amenities.area': 'Výměra:',
  'estimate_survey.step.flat_area_and_amenities.amenity_area.valid':
    'Minimální hodnota je&nbsp;1.',
  'estimate_survey.step.flat_area_and_amenities.warnings.amenity_area':
    'Uvedená plocha je neobvyklá a může mít velký vliv na odhad ceny.<br></br>Zkontrolujte prosím její správnost.',

  // other estate - appreciable unit
  'estimate_survey.step.appreciable_unit.title':
    'Je v budově byt, který chcete ocenit?',

  // other estate - appreciable unit
  'estimate_survey.step.other_estate_living_area.title':
    'Jaká je podlahová plocha objektu?',

  // flat disposition
  'estimate_survey.step.flat_disposition.title': 'Vyberte dispozici bytu',
  'estimate_survey.step.flat_disposition.title.check':
    'Souhlasí dispozice bytu?',
  'estimate_survey.step.flat_disposition.tooltip_title':
    'První číslo udává počet místností, druhé číslo počet samostatných kuchyní. Zkratka kk značí kuchyňský kout, který je součástí jiné místnosti. Nejmenší dispozicí je garsoniéra (studio), značená 1+kk.',
  'estimate_survey.step.flat_disposition.required':
    'Vyberte prosím dispozici bytu',

  // flat kitchen condition
  'estimate_survey.step.kitchen_condition.title': 'Určete stav kuchyně',
  'estimate_survey.step.kitchen_condition.title.check':
    'Souhlasí stav kuchyně?',

  // flat bathroom condition
  'estimate_survey.step.bathroom_condition.title': 'Určete stav koupelny',
  'estimate_survey.step.bathroom_condition.title.check':
    'Souhlasí stav koupleny?',

  // flat bathroom condition
  'estimate_survey.step.rooms_condition.title': 'Určete stav pokojů',
  'estimate_survey.step.rooms_condition.title.check': 'Souhlasí stav pokojů?',

  // flat floor
  'estimate_survey.step.flat_floor.title': 'Uveďte podlaží a přítomnost výtahu',
  'estimate_survey.step.flat_floor.title.check':
    'Ověřte podlaží a přítomnost výtahu',
  'estimate_survey.step.flat_floor.tooltip':
    'Podlaží, ve kterém se byt nachází, ovlivňuje výslednou cenu. Byty v nejnižších podlažích mají typicky nižší hodnotu. Obdobně na tom jsou byty ve vyšších podlažích, pokud v budově není výtah.',
  'estimate_survey.step.flat_floor.required': 'Vyplňte prosím podlaží',
  'estimate_survey.step.flat_floor.building_floors.required':
    'Vyplňte prosím počet podlaží',
  'estimate_survey.step.flat_floor.building_floors.larger_than_flat_floor':
    'Počet podlaží musí být stejný nebo větší než číslo podlaží bytu',
  'estimate_survey.step.flat_floor.elevator': 'Je v budově výtah?',
  'estimate_survey.step.flat_floor.elevator.required':
    'Uveďte prosím, zda je v budově výtah.',

  // flat ownership
  'estimate_survey.step.flat_ownership.title': 'Vyberte formu vlastnictví',
  'estimate_survey.step.flat_ownership.title.check':
    'Souhlasí forma vlastnictví?',
  'estimate_survey.step.flat_ownership.tooltip':
    'Byty v družstevním vlastnictví se obvykle prodávají za nižší cenu než byty ve vlastnictví soukromém. Obě varianty vlastnictví mají své klady i zápory.',

  // flat parking
  'estimate_survey.step.flat_parking.title':
    'Vlastníte k bytu parkovací stání?',
  'estimate_survey.step.flat_parking.tooltip':
    'Vlastnictví parkovacího stání významně zvyšuje hodnotu bytu. Pokud k bytu vlastnicky náleží venkovní nebo garážové parkovací stání, prosím, uveďte jej včetně jejich počtu.',
  'estimate_survey.step.flat_parking.tip':
    'Uveďte jen v případě, že jsou ve vašem osobním&nbsp;vlastnictví.',

  // flat construction type
  'estimate_survey.step.flat_construction.title': 'Zadejte typ stavby',
  'estimate_survey.step.flat_construction.title.check': 'Souhlasí typ stavby?',
  'estimate_survey.step.flat_construction.tooltip_title':
    'Cihlové domy mívají obvykle do 5 pater. Vyšší domy bývají typicky panelové nebo monolitické (především novostavby).',

  // flat parking
  'estimate_survey.step.parking_space': 'Venkovní park. stání',
  'estimate_survey.step.parking_space.count': 'Počet stání:',
  'estimate_survey.step.garage': 'Garáž',
  'estimate_survey.step.garage.count': 'Počet stání:',
  'estimate_survey.step.flat_parking.warnings.parking_spots':
    'Uvedený počet stání je neobvyklý a má velký vliv na konečný odhad ceny.<br></br>Zkontrolujte prosím správnost údaje.',

  // house amenities
  'estimate_survey.step.house_accessories.title':
    'Doplňte, co dalšího k domu patří‍',
  'estimate_survey.step.house_accessories.tooltip_title':
    'V tomto kroku vyplňte všechno příslušenství, které může hodnotu domu zvýšit.',
  'estimate_survey.field.house_accessories.parking': 'Garáž / Parkovací stání',
  'estimate_survey.field.house_accessories.pool': 'Bazén',
  'estimate_survey.field.house_accessories.fireplace': 'Krb',
  'estimate_survey.field.house_accessories.sauna': 'Sauna',
  'estimate_survey.field.house_accessories.pergola': 'Pergola',
  'estimate_survey.field.house_accessories.solar_panels': 'Solární panely',
  'estimate_survey.field.house_accessories.heat_pump': 'Tepelné čerpadlo',

  // house pool type
  'estimate_survey.step.pool_type.title': 'Upřesněte typ bazénu',
  'estimate_survey.field.pool_type.sunken': 'Zapuštěný',
  'estimate_survey.field.pool_type.semi_sunken': 'Polozapuštěný',
  'estimate_survey.field.pool_type.above_ground': 'Nadzemní',

  // house fireplace type
  'estimate_survey.step.fireplace_type.title': 'Upřesněte typ krbu',
  'estimate_survey.field.fireplace_type.burner_stove': 'Krbová kamna',
  'estimate_survey.field.fireplace_type.built_in': 'Zabudovaný krb',
  'estimate_survey.field.fireplace_type.tiled':
    'Kachlová kamna se sporákem nebo pecí',

  // house sauna type
  'estimate_survey.step.sauna_type.title': 'Upřesněte typ sauny',
  'estimate_survey.field.sauna_type.basic': 'Základní',
  'estimate_survey.field.sauna_type.luxurious': 'Luxusní',

  // house pergola type
  'estimate_survey.step.pergola_type.title': 'Upřesněte typ pergoly',
  'estimate_survey.field.pergola_type.classic': 'Klasická',
  'estimate_survey.field.pergola_type.glassed': 'Zasklená',
  'estimate_survey.field.pergola_type.bio_climatic': 'Bioklimatická',

  // house solar panels purpose
  'estimate_survey.step.solar_panel_purpose.title':
    'Jaký je způsob využití solárních panelů?',
  'estimate_survey.field.solar_panel_purpose.electricity_generation':
    'Výroba elektřiny',
  'estimate_survey.field.solar_panel_purpose.water_heating': 'Ohřev vody',
  'estimate_survey.field.solar_panel_purpose.electricity_generation_water_heating':
    'Obojí',

  // house solar panels area
  'estimate_survey.step.solar_panel_area.title':
    'Doplňte plochu solárních panelů',
  'estimate_survey.field.solar_panel_area.input.label': 'Plocha panelů',
  'estimate_survey.field.solar_panel_area.input.error.required':
    'Zadejte prosím plochu panelů',
  'estimate_survey.field.solar_panel_area.input.error.positive':
    'Zadejte prosím kladnou plochu panelů',

  // house heat pump type
  'estimate_survey.step.heat_pump_type.title':
    'Upřesněte typ tepelného čerpedla',
  'estimate_survey.field.heat_pump_type.air_air': 'Vzduch-vzduch',
  'estimate_survey.field.heat_pump_type.air_water': 'Vzduch-voda',
  'estimate_survey.field.heat_pump_type.water_water': 'Voda-voda',
  'estimate_survey.field.heat_pump_type.ground_water': 'Země-voda',

  // building exact finished at
  'estimate_survey.step.building_exact_finished_at.title':
    'Znáte přesný rok výstavby?',

  // building finished at
  'estimate_survey.step.building_finished_at.title': 'Zadejte rok výstavby',
  'estimate_survey.step.building_finished_at.verify.title':
    'Potvrďte rok výstavby',
  'estimate_survey.step.building_finished_at.verify.subtitle':
    'Pokud údaj nesedí, opravte jej prosím.',
  'estimate_survey.step.building_finished_at.required':
    'Zadejte prosím rok výstavby',
  'estimate_survey.step.building_finished_at.min_max':
    'Rok výstavby musí být větší než 1900 a nižší než letošní rok',

  // building finished at interval
  'estimate_survey.step.building_finished_at_interval.title':
    'Vyberte orientační rok výstavby',
  'estimate_survey.step.building_finished_at_interval.verify.title':
    'Potvrďte orientační rok výstavby',

  // estimate reason
  'estimate_survey.step.estimate_reason.title': 'Proč si odhad počítáte?',
  'estimate_survey.step.estimate_reason.subtitle':
    'Odpověď nám pomůže ke zkvalitnění služby a nemá vliv na výsledek.',

  // Flat
  'estimate_survey.field.estimate_reason.flat.consider_selling':
    'Uvažuji o prodeji',
  'estimate_survey.field.estimate_reason.flat.consider_buying':
    'Uvažuji o koupi',
  'estimate_survey.field.estimate_reason.flat.owner': 'Vlastním tento byt',
  'estimate_survey.field.estimate_reason.flat.other': 'Jiný důvod',

  // House
  'estimate_survey.field.estimate_reason.house.consider_selling':
    'Uvažuji o prodeji',
  'estimate_survey.field.estimate_reason.house.consider_buying':
    'Uvažuji o koupi',
  'estimate_survey.field.estimate_reason.house.owner': 'Vlastním tento dům',
  'estimate_survey.field.estimate_reason.house.other': 'Jiný důvod',

  // Land
  'estimate_survey.field.estimate_reason.land.consider_selling':
    'Uvažuji o prodeji',
  'estimate_survey.field.estimate_reason.land.consider_buying':
    'Uvažuji o koupi',
  'estimate_survey.field.estimate_reason.land.owner': 'Vlastním tento pozemek',
  'estimate_survey.field.estimate_reason.land.other': 'Jiný důvod',

  // Other
  'estimate_survey.field.estimate_reason.other.consider_selling':
    'Uvažuji o prodeji',
  'estimate_survey.field.estimate_reason.other.consider_buying':
    'Uvažuji o koupi',
  'estimate_survey.field.estimate_reason.other.owner':
    'Vlastním tuto nemovitost',
  'estimate_survey.field.estimate_reason.other.other': 'Jiný důvod',

  // requalification step
  'estimate_survey.steps.requalification.title':
    'Chcete zjistit, kolik můžete získat prodejem nemovitosti?',
  'estimate_survey.steps.requalification.subtitle':
    'Ve vaší lokalitě evidujeme zájemce o koupi nemovitosti podobné té vaší.',
  'estimate_survey.field.requalification.yes': 'Ano, přemýšlím o prodeji',
  'estimate_survey.field.requalification.no': 'Ne, nemám zájem prodávat',

  // RESULT PAGE
  // meta
  'estimate_survey.result_page.meta.title': 'Prodej nemovitosti bez starostí',

  // amenity warning
  'estimate_survey.result_page.amenity_warning':
    'Odhad může být zkreslený vzhledem k zadaným hodnotám: {firstAmenityText}{otherAmenitiesText}.',
  'estimate_survey.result_page.amenity_warning.garden': 'Zahrada ({amount} m²)',
  'estimate_survey.result_page.amenity_warning.balcony': 'Balkon ({amount} m²)',
  'estimate_survey.result_page.amenity_warning.loggia': 'Lodžie ({amount} m²)',
  'estimate_survey.result_page.amenity_warning.terrace': 'Terasa ({amount} m²)',
  'estimate_survey.result_page.amenity_warning.cellar': 'Sklep ({amount} m²)',
  'estimate_survey.result_page.amenity_warning.garage':
    'Garáž ({amount} stání)',
  'estimate_survey.result_page.amenity_warning.parking_space':
    'Parkovací stání ({amount} stání)',
  'estimate_survey.result_page.amenity_warning.covered_parking_space':
    'Kryté parkovací stání ({amount} stání)',
  'estimate_survey.result_page.amenity_warning.uncovered_parking_space':
    'Nekryté parkovací stání ({amount} stání)',
  'estimate_survey.result_page.amenity_warning.conjunction': ' a ',
  'estimate_survey.result_page.amenity_warning.other_amenities': `{count, plural,
    one {další}
    few {další}
    other {dalších}
  } {count}`,

  // panorama section
  'estimate_survey.result_page.panorama.bullet': '• ',
  'estimate_survey.result_page.panorama.floor_area': ' •&nbsp{area}&nbsp;m²',
  'estimate_survey.result_page.panorama.unit_number':
    ' •&nbspJednotka č.:&nbsp{unitNumber}',

  // estimate section
  'estimate_survey.result_page.estimate.title_tooltip.flat':
    'Odhad ceny jsme vypočítali na základě dat o podobných bytech prodaných v okolí a zohlednili přitom zadané parametry bytu (viz níže).<br></br>Ceny prodaných bytů vychází z aktuálních dat Katastru nemovitostí.',
  'estimate_survey.result_page.estimate.title_tooltip.house':
    'Odhad ceny jsme vypočítali na základě dat o podobných domech prodaných v okolí a zohlednili přitom zadané parametry domu (viz níže).<br></br>Ceny prodaných domů vychází z aktuálních dat Katastru nemovitostí.',
  'estimate_survey.result_page.estimate.title': 'Odhadovaná cena',
  'estimate_survey.result_page.estimate.error':
    'Při počítání odhadu došlo k chybě, zkuste prosím obnovit stránku nebo to zkuste později.',
  'estimate_survey.result_page.estimate.price_range_millions':
    '{low}&nbsp;mil. - {high}&nbsp;mil.',
  'estimate_survey.result_page.estimate.price_millions': '{mid}&nbsp;mil.',
  'estimate_survey.result_page.estimate.price': '{estimate}&nbsp;Kč',
  'estimate_survey.result_page.estimate.price_feedback':
    'Očekávali jste jinou cenu? {feedbackLink}',
  'estimate_survey.result_page.estimate.price_feedback_link':
    ' Pošlete nám zpětnou vazbu.',
  'estimate_survey.result_page.estimate.subscribe.button': 'Sledovat cenu',
  'estimate_survey.result_page.estimate.no_estimate.title':
    'Omlouváme se, cenu této nemovitosti zatím nedokážeme spolehlivě odhadnout na dálku.',

  'estimate_survey.result_page.estimate.confidence.tooltip':
    '<b>Míra jistoty odpovídá množství dat, jimiž disponujeme o podobných nemovitostech prodaných v okolí.</b><br/><br/>Nízká jistota může být způsobena tím, že není dost dat o nedávných prodejích a nebo je vaše nemovitost jedinečná. Pokud je jistota vysoká, máme nejspíše více dostupných dat o podobných prodaných nemovitostech v okolí.',
  'estimate_survey.result_page.estimate.confidence.high':
    'Velmi vysoká jistota',
  'estimate_survey.result_page.estimate.confidence.medium': 'Vysoká jistota',
  'estimate_survey.result_page.estimate.confidence.low': 'Střední jistota',
  'estimate_survey.result_page.estimate.confidence.terrible': 'Nízká jistota',

  // get offer section - flat
  'estimate_survey.result_page.get_offer.title': 'Přemýšlíte o prodeji bytu?',
  'estimate_survey.result_page.get_offer.copy':
    'Máme přes 150 zkušených makléřů po celé ČR, kteří prodají váš byt za maximální cenu. Získejte ZDARMA profesionální odhad pro upřesnění ceny před prodejem.',
  'estimate_survey.result_page.get_offer.cta': 'Chci profesionální odhad',

  // get offer B section - flat
  'estimate_survey.result_page.get_offer_b.title': 'Chcete prodat váš byt?',
  'estimate_survey.result_page.get_offer_b.copy':
    'Podobný byt s námi aktuálně <b>hledá 65 zájemců</b>',
  'estimate_survey.result_page.get_offer_b.cta': 'Zjistit zájem',

  // get offer section - house
  'estimate_survey.result_page.get_offer.house.title':
    'Přemýšlíte o prodeji domu?',
  'estimate_survey.result_page.get_offer.house.copy':
    'Máme přes 150 zkušených makléřů po celé ČR, kteří prodají váš dům za maximální cenu. Získejte profesionální odhad pro upřesnění ceny před prodejem.',

  // get offer B section - house
  'estimate_survey.result_page.get_offer_b.house.title':
    'Chcete prodat váš dům?',
  'estimate_survey.result_page.get_offer_b.house.copy':
    'Podobný dům s námi aktuálně <b>hledá 65 zájemců</b>',

  // get offer section - house subscribe
  'estimate_survey.result_page.house.subscribe.title':
    'Nový odhad ceny domu již brzy!',
  'estimate_survey.result_page.house.subscribe.copy':
    'Usilovně pracujeme na tom, abychom spočítali odhad ceny online i pro tento dům. Spuštění plánujeme na prosinec 2021.',
  'estimate_survey.result_page.house.subscribe.cta': 'Chci být informován',

  // get offer section B variant
  'estimate_survey.result_page.io_video_modal.cta': 'Získat cenovou nabídku',
  'estimate_survey.result_page.io_video_modal.cta_subtext':
    'Zdarma a bez závazků',

  // want to buy
  'estimate_survey.result_page.get_offer.want_to_buy.title':
    'Hledáte nemovitost ke koupi?',
  'estimate_survey.result_page.get_offer.want_to_buy.copy':
    'Dostaňte se k prodávaným nemovitostem dříve, než se začnou inzerovat. Pošleme vám jen relevantní nabídky.',
  'estimate_survey.result_page.get_offer.want_to_buy.cta':
    'Vytvořit ZDARMA poptávku',

  // Offer survey link section
  'estimate_survey.result_page.get_offer_link.title': 'Přemýšlíte o prodeji?',
  'estimate_survey.result_page.get_offer_link.subtitle':
    'Vyplňte nám, prosím, několik nezbytných informací o vaší nemovitosti a naši realitní specialisté se s vámi obratem spojí.',
  'estimate_survey.result_page.get_offer_link.button': 'Získat nabídku',

  // show in Atlas section
  'estimate_survey.result_page.atlas.title': 'Zajímá vás více informací?',
  'estimate_survey.result_page.atlas.subtitle':
    'Zjistěte, jak se cena této nemovitosti vyvíjí v čase nebo za kolik se prodávají nemovitosti v okolí.',
  'estimate_survey.result_page.atlas.button': 'Zobrazit v Atlasu cen',

  // no info section
  'estimate_survey.result_page.estate_info.table.no_estimate':
    'Bohužel, cenu této nemovitosti zatím nedokážeme spolehlivě odhadnout.',

  // info section - table
  'estimate_survey.result_page.estate_info.table.title':
    'Podrobnosti o nemovitosti',
  'estimate_survey.result_page.estate_info.table.atlas_link':
    'Upravit údaje (otevře Atlas cen)',
  'estimate_survey.result_page.estate_info.table.type': 'Typ nemovitosti',
  'estimate_survey.result_page.estate_info.table.building_type':
    'Typ nemovitosti',
  'estimate_survey.result_page.estate_info.table.floor_area':
    'Podlahová plocha',
  'estimate_survey.result_page.estate_info.table.land_area': 'Plocha pozemku',
  'estimate_survey.result_page.estate_info.table.disposition': 'Dispozice',
  'estimate_survey.result_page.estate_info.table.unit_number': 'Číslo jednotky',
  'estimate_survey.result_page.estate_info.table.ownership': 'Vlastnictví',
  'estimate_survey.result_page.estate_info.table.construction_type':
    'Typ konstrukce',
  'estimate_survey.result_page.estate_info.table.floor': 'Podlaží bytu',
  'estimate_survey.result_page.estate_info.table.floors_count': 'Počet podlaží',
  'estimate_survey.result_page.estate_info.table.elevator': 'Výtah',
  'estimate_survey.result_page.estate_info.table.finished_at': 'Rok výstavby',
  'estimate_survey.result_page.estate_info.table.finished_at_interval':
    'Rok výstavby',
  'estimate_survey.result_page.estate_info.table.building_condition':
    'Stav&nbsp;budovy',
  'estimate_survey.result_page.estate_info.table.kitchen_condition':
    'Stav&nbsp;kuchyně',
  'estimate_survey.result_page.estate_info.table.bathroom_condition':
    'Stav&nbsp;koupelny',
  'estimate_survey.result_page.estate_info.table.house_separation':
    'Poloha domu',
  'estimate_survey.result_page.estate_info.table.nearby_traffic_routes':
    'Rušná dopravní tepna',

  'estimate_survey.result_page.estate_info.table.area': '{floorArea}&nbsp;m²',

  // estate type
  'estimate_survey.result_page.estate_info.table.type.flat': 'Byt',
  'estimate_survey.result_page.estate_info.table.type.house': 'Dům',
  'estimate_survey.result_page.estate_info.table.type.commercial_object':
    'Komerční objekt',
  'estimate_survey.result_page.estate_info.table.type.other': 'Jiné',
  'estimate_survey.result_page.estate_info.table.type.land': 'Pozemek',

  // building type
  'estimate_survey.result_page.estate_info.table.building_type.family_house':
    'Rodinný dům',
  'estimate_survey.result_page.estate_info.table.building_type.recreational_building':
    'Rekreační',
  'estimate_survey.result_page.estate_info.table.building_type.other': 'Jiné',

  // dispositions
  'estimate_survey.result_page.estate_info.table.disposition.1+kk': '1+kk',
  'estimate_survey.result_page.estate_info.table.disposition.1+1': '1+1',
  'estimate_survey.result_page.estate_info.table.disposition.2+kk': '2+kk',
  'estimate_survey.result_page.estate_info.table.disposition.2+1': '2+1',
  'estimate_survey.result_page.estate_info.table.disposition.3+kk': '3+kk',
  'estimate_survey.result_page.estate_info.table.disposition.3+1': '3+1',
  'estimate_survey.result_page.estate_info.table.disposition.4+kk': '4+kk',
  'estimate_survey.result_page.estate_info.table.disposition.4+1': '4+1',
  'estimate_survey.result_page.estate_info.table.disposition.4+1_and_larger':
    '4+1 a větší',
  'estimate_survey.result_page.estate_info.table.disposition.larger':
    '5+kk a větší',

  // ownership
  'estimate_survey.result_page.estate_info.table.ownership.private': 'Osobní',
  'estimate_survey.result_page.estate_info.table.ownership.collective':
    'Družstevní',
  'estimate_survey.result_page.estate_info.table.ownership.national_or_municipal':
    'Státní/obecní',
  'estimate_survey.result_page.estate_info.table.ownership.mixed': 'Smíšené',
  'estimate_survey.result_page.estate_info.table.ownership.other': 'Jiné',

  // conditions
  'estimate_survey.result_page.estate_info.table.conditions.excellent':
    'Výborný',
  'estimate_survey.result_page.estate_info.table.conditions.newish': 'Zánovní',
  'estimate_survey.result_page.estate_info.table.conditions.good': 'Dobrý',
  'estimate_survey.result_page.estate_info.table.conditions.bad': 'Špatný',

  // construction types
  'estimate_survey.result_page.estate_info.table.construction_type.brick_cinder_block':
    'Cihla',
  'estimate_survey.result_page.estate_info.table.construction_type.stone':
    'Cihla',
  'estimate_survey.result_page.estate_info.table.construction_type.brick_stone':
    'Cihla',
  'estimate_survey.result_page.estate_info.table.construction_type.brick':
    'Cihla',
  'estimate_survey.result_page.estate_info.table.construction_type.panel':
    'Panel',
  'estimate_survey.result_page.estate_info.table.construction_type.mudbrick':
    'Cihla',
  'estimate_survey.result_page.estate_info.table.construction_type.wood':
    'Dřevo',
  'estimate_survey.result_page.estate_info.table.construction_type.other':
    'Jiný',
  'estimate_survey.result_page.estate_info.table.construction_type.brick_stone_cinder_block':
    'Cihla',
  'estimate_survey.result_page.estate_info.table.construction_type.monolith':
    'Monolit',
  'estimate_survey.result_page.estate_info.table.construction_type.unknown':
    'Neznámý',

  'estimate_survey.result_page.estate_info.table.house_separation.terraced':
    'Řadový / v bloku',
  'estimate_survey.result_page.estate_info.table.house_separation.stand_alone':
    'Samostatný',

  'estimate_survey.result_page.estate_info.table.nearby_traffic_routes.airport':
    'Letiště',
  'estimate_survey.result_page.estate_info.table.nearby_traffic_routes.railway':
    'Železnice',
  'estimate_survey.result_page.estate_info.table.nearby_traffic_routes.main_road':
    'Silnice / Dálnice',

  'estimate_survey.result_page.estate_info.table.elevator.has_elevator': 'Ano',
  'estimate_survey.result_page.estate_info.table.elevator.no_elevator': 'Ne',
  'estimate_survey.result_page.estate_info.table.elevator.unknown':
    'Nezjištěno',

  // yes no
  'estimate_survey.result_page.estate_info.table.yes': 'Ano',
  'estimate_survey.result_page.estate_info.table.no': 'Ne',

  'estimate_survey.result_page.estate_info.table.unknown': 'Neznámý',

  // info section - amenities
  'estimate_survey.result_page.estate_info.amenities.title': 'Příslušenství',
  'estimate_survey.result_page.estate_info.amenities.garden_value':
    'Zahrada ({value}&nbsp;m²)',
  'estimate_survey.result_page.estate_info.amenities.balcony_value':
    'Balkon ({value}&nbsp;m²)',
  'estimate_survey.result_page.estate_info.amenities.loggia_value':
    'Lodžie ({value}&nbsp;m²)',
  'estimate_survey.result_page.estate_info.amenities.terrace_value':
    'Terasa ({value}&nbsp;m²)',
  'estimate_survey.result_page.estate_info.amenities.cellar_value':
    'Sklep ({value}&nbsp;m²)',
  'estimate_survey.result_page.estate_info.amenities.garage_value':
    'Garáž ({value} stání)',
  'estimate_survey.result_page.estate_info.amenities.parking_space_value':
    'Parkování ({value}&nbsp;stání)',
  'estimate_survey.result_page.estate_info.amenities.covered_parking_space_value':
    'Kryté parkování ({value}&nbsp;stání)',
  'estimate_survey.result_page.estate_info.amenities.uncovered_parking_space_value':
    'Nekryté parkování ({value}&nbsp;stání)',
  'estimate_survey.result_page.estate_info.amenities.pool_type_value':
    'Bazén ({value})',
  'estimate_survey.result_page.estate_info.amenities.pergola_type_value':
    'Pergola ({value})',
  'estimate_survey.result_page.estate_info.amenities.solar_panel_value':
    'Solární panely ({value})',
  'estimate_survey.result_page.estate_info.amenities.heat_pump_type_value':
    'Tepelné čerpadlo ({value})',
  'estimate_survey.result_page.estate_info.amenities.fireplace_type_value':
    'Krb ({value})',
  'estimate_survey.result_page.estate_info.amenities.sauna_type_value':
    'Sauna ({value})',
  'estimate_survey.result_page.estate_info.amenities.garden': 'Zahrada',
  'estimate_survey.result_page.estate_info.amenities.balcony': 'Balkon',
  'estimate_survey.result_page.estate_info.amenities.loggia': 'Lodžie',
  'estimate_survey.result_page.estate_info.amenities.terrace': 'Terasa',
  'estimate_survey.result_page.estate_info.amenities.cellar': 'Sklep',
  'estimate_survey.result_page.estate_info.amenities.garage': 'Garáž',
  'estimate_survey.result_page.estate_info.amenities.parking_space':
    'Parkování',

  'estimate_survey.result_page.estate_info.amenities.pool_type.sunken':
    'Zapuštěný',
  'estimate_survey.result_page.estate_info.amenities.pool_type.semi_sunken':
    'Polozapuštěný',
  'estimate_survey.result_page.estate_info.amenities.pool_type.above_ground':
    'Nadzemní',
  'estimate_survey.result_page.estate_info.amenities.pergola_type.classic':
    'Klasická',
  'estimate_survey.result_page.estate_info.amenities.pergola_type.glassed':
    'Zasklená',
  'estimate_survey.result_page.estate_info.amenities.pergola_type.bio_climatic':
    'Bioklimatická',

  'estimate_survey.result_page.estate_info.amenities.solar_panel.electricity_generation':
    'Výroba elektřiny',
  'estimate_survey.result_page.estate_info.amenities.solar_panel.water_heating':
    'Ohřev vody',
  'estimate_survey.result_page.estate_info.amenities.solar_panel.electricity_generation_water_heating':
    'Ohřev + Elektřina',

  'estimate_survey.result_page.estate_info.amenities.heat_pump_type.air_air':
    'Vzduch-vzduch',
  'estimate_survey.result_page.estate_info.amenities.heat_pump_type.air_water':
    'Vzduch-voda',
  'estimate_survey.result_page.estate_info.amenities.heat_pump_type.water_water':
    'Voda-voda',
  'estimate_survey.result_page.estate_info.amenities.heat_pump_type.ground_water':
    'Země-voda',

  'estimate_survey.result_page.estate_info.amenities.fireplace_type.burner_stove':
    'Krbová kamna',
  'estimate_survey.result_page.estate_info.amenities.fireplace_type.built_in':
    'Zabudovaný krb',
  'estimate_survey.result_page.estate_info.amenities.fireplace_type.tiled':
    'Kachlová kamna se sporákem nebo pecí',

  'estimate_survey.result_page.estate_info.amenities.sauna_type.basic':
    'Základní',
  'estimate_survey.result_page.estate_info.amenities.sauna_type.luxurious':
    'Luxusní',

  'estimate_survey.result_page.estate_info.amenities.area': '{value}&nbsp;m²',

  // price graph
  'estimate_survey.result_page.price_graph.price_millions': '{price} mil.',
  'estimate_survey.result_page.price_graph.price_millions_with_currency':
    '{price} mil. Kč',
  'estimate_survey.result_page.price_graph.title': 'Vývoj ceny v čase',

  'estimate_survey.result_page.differences': '{percents}%',
  'estimate_survey.result_page.differences.approx_diff_price': '{price}',

  'estimate_survey.result_page.title.last_3_months': 'Poslední 3 měsíce',
  'estimate_survey.result_page.title.last_year': 'Poslední rok',

  // get offer modal

  // Default
  'estimate_survey.result_page.modal.get_offer.title':
    'Pro získání odhadu vyplňte kontaktní údaje',
  'estimate_survey.result_page.modal.get_offer.subtitle':
    'Zjistěte nezávazně a zdarma odhad ceny nemovitosti a jak nejlépe prodat.',
  'estimate_survey.result_page.modal.get_offer.full_name': 'Jméno a příjmení',
  'estimate_survey.result_page.modal.get_offer.email': 'E-mail',
  'estimate_survey.result_page.modal.get_offer.phone_number': 'Telefon',
  'estimate_survey.result_page.modal.get_offer.button': 'Chci odhad ceny',
  'estimate_survey.result_page.modal.get_offer.thank_you.title':
    'Vaši poptávku jsme v pořádku přijali.',
  'estimate_survey.result_page.modal.get_offer.button.triggered_by_url_parameter':
    'Odeslat a zobrazit odhad',
  'estimate_survey.result_page.modal.get_offer.thank_you.subtitle':
    'Vaši poptávku jsme v pořádku přijali. Brzy se vám ozveme s&nbsp;nabídkou a&nbsp;navrhneme vám další postup.',
  'estimate_survey.result_page.modal.get_offer.thank_you.subtitle_triggered_by_url':
    'Brzy se vám ozveme a navrhneme vám další postup.',
  'estimate_survey.result_page.modal.get_offer.thank_you.button_triggered_by_url':
    'Zobrazit odhad ceny',

  // subscribe modal
  'estimate_survey.result_page.modal.subscribe.title':
    'Sledujte cenu tohoto bytu',
  'estimate_survey.result_page.modal.subscribe.subtitle':
    '1x měsíčně obdržíte e-mail s informacemi:',
  'estimate_survey.result_page.modal.subscribe.benefit_1':
    'Co se v okolí prodalo a za kolik',
  'estimate_survey.result_page.modal.subscribe.benefit_2':
    'Aktuální odhad ceny bytu',
  'estimate_survey.result_page.modal.subscribe.benefit_3':
    'Realitní trendy v lokalitě',
  'estimate_survey.result_page.modal.subscribe.unit_number':
    'Jednotka č. {unitNumber}',
  'estimate_survey.result_page.modal.subscribe.unknown_unit':
    'Neznámá jednotka',
  'estimate_survey.result_page.modal.subscribe.email': 'E-mail',
  'estimate_survey.result_page.modal.subscribe.placeholder':
    'Zadejte vaši e-mailovou adresu',
  'estimate_survey.result_page.modal.subscribe.button': 'Nastavit sledování',
  'estimate_survey.result_page.modal.subscribe.thank_you':
    'Brzy se můžete těšit na aktuální informace o prodejích a cenách vybraného bytu.',

  // house subscribe modal
  'estimate_survey.result_page.modal.house_subscribe.title':
    'Sledujte ZDARMA cenu tohoto domu',
  'estimate_survey.result_page.modal.house_subscribe.subtitle':
    'Buďte pravidelně informováni o vývoji ceny této nemovitosti. Sledování můžete kdykoliv zrušit.',
  'estimate_survey.result_page.modal.house_subscribe.benefit_1':
    'Co se v okolí prodalo a za kolik',
  'estimate_survey.result_page.modal.house_subscribe.benefit_2':
    'Aktuální odhad ceny bytu',
  'estimate_survey.result_page.modal.house_subscribe.benefit_3':
    'Realitní trendy v lokalitě',
  'estimate_survey.result_page.modal.house_subscribe.unit_number':
    'Jednotka č. {unitNumber}',
  'estimate_survey.result_page.modal.house_subscribe.unknown_unit':
    'Neznámá jednotka',
  'estimate_survey.result_page.modal.house_subscribe.email.label': 'E-mail',
  'estimate_survey.result_page.modal.house_subscribe.email.placeholder':
    'Zadejte vaši e-mailovou adresu',
  'estimate_survey.result_page.modal.house_subscribe.button':
    'Nastavit sledování',
  'estimate_survey.result_page.modal.house_subscribe.thank_you.title':
    'Sledování ceny je nastaveno',
  'estimate_survey.result_page.modal.house_subscribe.thank_you.subtitle':
    'Blahopřejeme, začal/a jste sledovat cenu domu na&nbsp;adrese <b>{address}.</b>',

  // house subscribe modal
  'estimate_survey.result_page.modal.house-subscribe.title': `{days}&nbsp;{days, plural,
      one {den}
      few {dny}
      other {dní}
    },
    {hours}&nbsp;{hours, plural,
      one {hodina}
      few {hodiny}
      other {hodin}
    },
    {minutes}&nbsp;{minutes, plural,
      one {minuta}
      few {minuty}
      other {minut}
    },
    {seconds}&nbsp;{seconds, plural,
      one {sekunda}
      few {sekundy}
      other {sekund}
    }`,
  'estimate_survey.result_page.modal.house-subscribe.subtitle':
    'zbývá do <strong>spuštění online odhadu na domy.</strong>',
  'estimate_survey.result_page.modal.house-subscribe.copy':
    'Zadejte svůj e-mail a dáme vám vědět ihned, jakmile odhad domu online spustíme.',
  'estimate_survey.result_page.modal.house-subscribe.email': 'Váš e-mail',
  'estimate_survey.result_page.modal.house-subscribe.placeholder':
    'Zadejte vaši e-mailovou adresu',
  'estimate_survey.result_page.modal.house-subscribe.button': 'Dejte mi vědět',
  'estimate_survey.result_page.modal.house-subscribe.thank_you.title':
    'Děkujeme za důvěru',
  'estimate_survey.result_page.modal.house-subscribe.thank_you.subtitle':
    'Budete mezi prvními, kteří budou moct vyzkoušet nový odhad ceny domu.',

  // modal - thank you
  'estimate_survey.result_page.modal.thank_you.title': 'Hotovo',
  'estimate_survey.result_page.modal.thank_you.close': 'Zavřít',

  'estimate_survey.result_page.open_atlas_section.title':
    'Za kolik se prodaly byty v okolí?',
  'estimate_survey.result_page.open_atlas_section.content':
    'Zjistěte, za kolik se prodávají nemovitosti kolem vás. Nastavte si bezplatné hlídání cen a nic vám už neunikne.',
  'estimate_survey.result_page.open_atlas_section.cta': 'Otevřít cenovou mapu',

  'estimate_survey.step.select_estimate_type.title': 'Vyberte si typ odhadu',
  'estimate_survey.step.select_estimate_type.description':
    'Na základě vámi zadaných údajů vám <b>doporučujeme Profesionální odhad.</b>',
  'estimate_survey.step.select_estimate_type.professional_estimate.title':
    'Profesionální odhad',
  'estimate_survey.step.select_estimate_type.professional_estimate.label':
    'Doporučujeme před prodejem',
  'estimate_survey.step.select_estimate_type.professional_estimate.bullets.exact_estimate':
    'Přesný odhad ceny nemovitosti',
  'estimate_survey.step.select_estimate_type.professional_estimate.bullets.advice':
    'Poradíme, jak nejlépe prodat',
  'estimate_survey.step.select_estimate_type.professional_estimate.bullets.free':
    'ZDARMA a nezávazně',

  'estimate_survey.step.select_estimate_type.online_estimate.title':
    'Online odhad',
  'estimate_survey.step.select_estimate_type.online_estimate.bullets.rough_estimate':
    'Hrubý orientační odhad',
  'estimate_survey.step.select_estimate_type.online_estimate.bullets.immediately':
    'Okamžitě, bez dalších údajů',

  // estate condition step
  'estimate_survey.step.house_condition.title': 'V jakém stavu je stavba',
  'estimate_survey.step.house_condition.excellent': 'Výborný',
  'estimate_survey.step.house_condition.excellent.text':
    'Po rekonstrukci nebo do 2&nbsp;let stáří',
  'estimate_survey.step.house_condition.newish': 'Zánovní',
  'estimate_survey.step.house_condition.newish.text':
    'Drobné nedostatky, stáří od&nbsp;2&nbsp;do&nbsp;10&nbsp;let',
  'estimate_survey.step.house_condition.good': 'Dobrý',
  'estimate_survey.step.house_condition.good.text':
    'Jsou nutné opravy, stáří 10&nbsp;let a&nbsp;více',
  'estimate_survey.step.house_condition.bad': 'Špatný',
  'estimate_survey.step.house_condition.bad.text':
    'Objekt ke kompletní rekonstrukci či demolici',

  // house parking step
  'estimate_survey.step.house_parking.title':
    'Jaká forma parkování k domu náleží?',
  'estimate_survey.step.house_parking.subtitle':
    'Vyberte prosím typ a <b>upřesněte počet stání.</b>',
  'estimate_survey.step.house_parking.garage': 'Garáž',
  'estimate_survey.step.house_parking.covered_parking_space':
    'Kryté parkovací místo',
  'estimate_survey.step.house_parking.uncovered_parking_space':
    'Nekryté parkovací místo',

  // errors
  'estimate_survey.step.house_parking.fields.errors.min': 'Minimum je 1.',
  'estimate_survey.step.house_parking.fields.errors.number_required':
    'Zadejte počet.',

  // warnings
  'estimate_survey.step.house_parking.fields.warnings.max':
    'Uvedený počet stání je neobvyklý a může mít vliv na konečný odhad ceny. Zkontrolujte prosím správnost údaje.',

  // house floors count
  'estimate_survey.field.house_floors_count.options.1': '1 podlaží',
  'estimate_survey.field.house_floors_count.options.2': '2 podlaží',
  'estimate_survey.field.house_floors_count.options.3': '3 podlaží',
  'estimate_survey.field.house_floors_count.options.4': '4 podlaží',
  'estimate_survey.field.house_floors_count.options.5': 'Více než 4 podlaží',
  'estimate_survey.step.house_floors_count.title': 'Kolik podlaží dům má?',
  'estimate_survey.step.house_floors_count.tooltip':
    'Víte, že podlaží není to samé jako patro? U podlaží rozlišujeme, zda se jedná o nadzemní podlaží (NP) nebo podzemní podlaží (PP). Uveďte prosím celkový počet podlaží (součet PP a NP).<br></br><b>Příklad:</b><br></br>Podsklepení domu = 1.PP<br></br>Přízemí = 1.NP<br></br>1.patro = 2.NP<br></br>Tzn. celkem 3 podlaží',

  'estimate_survey.step.house_floors_count_confirmation.title':
    'Potvrďte počet podlaží',
  'estimate_survey.step.house_floors_count_confirmation.subtitle':
    'Pokud údaj nesedí, opravte jej prosím.',
  'estimate_survey.step.house_floors_count_confirmation.label': 'Počet podlaží',

  'estimate_survey.step.house_floors_count.errors.min':
    'Počet podlaží nesmí být menší než {number}.',

  'estimate_survey.step.house_floors_count.errors.type_check':
    'Počet podlaží musí být číslo.',

  'estimate_survey.step.house_floors_count_input.title':
    'Upřesněte počet podlaží',
  'estimate_survey.step.house_floors_count_input.label': 'Počet podlaží',

  'estimate_survey.step.house_separation.title': 'Jaká je poloha domu?',
  'estimate_survey.field.house_separation.options.stand_alone':
    'Samostatně stojící',
  'estimate_survey.field.house_separation.options.stand_alone.info':
    'Dům stojí na pozemku samostatně',
  'estimate_survey.field.house_separation.options.terraced': 'Řadový / v bloku',
  'estimate_survey.field.house_separation.options.terraced.info':
    'Dům alespoň z jedné strany navazuje na další domy v ulici',

  'estimate_survey.step.nearby_traffic_route.title':
    'Je v blízkosti domu rušná dopravní tepna?',

  'estimate_survey.step.nearby_traffic_routes.title':
    'Jaké rušné dopravní tepny se v okolí nachází?',
  'estimate_survey.step.nearby_traffic_routes.options.main_road':
    'Silnice / Dálnice',
  'estimate_survey.step.nearby_traffic_routes.options.railway': 'Železnice',
  'estimate_survey.step.nearby_traffic_routes.options.airport': 'Letiště',

  // owner
  'estimate_survey.step.owner.title': 'Jste majitel?',
  'estimate_survey.field.is_owner.yes': 'Ano',
  'estimate_survey.field.is_owner.no': 'Ne',
  'estimate_survey.field.is_owner.represent': 'Zastupuji majitele',
  // owners approval
  'estimate_survey.step.owners_approval.title':
    'Souhlasí všichni majitelé s prodejem?',
};
